import React from 'react';
import css from '../css/module/chart-hints.css';

// text used across the site to explain features

export const COMPARE_PERIODS_EXPLAINER = (
  <span>
    <p>
      When toggled, you'll see each period (e.g. each year) as a{' '}
      <b>separate line</b> on the chart.
    </p>
    <p>
      This option is available for <b>Line charts</b> when you use a{' '}
      <b>summarize step</b> in the Query Builder with <b>one metric</b> and{' '}
      <b>one dimension (must be a date)</b>.
    </p>
    <img width="620" height="435" src="/img/comparePeriods.png" />
    <p>
      Currently, you can compare different <b>months</b> (when your date
      dimension is set to <b>DAY</b>) and <b>years</b> (when your date dimension
      is set to <b>MONTH</b>).
    </p>
    <p>
      Important: the chart <b>only</b> has access to the dates{' '}
      <b>returned by your query</b>, so be sure to include the entire data range
      you're interested in.
    </p>
  </span>
);

export const CUMULATIVE_EXPLAINER = (
  <span>
    <p>
      When toggled, you'll see the <b>cumulative</b> or <b>running total</b>{' '}
      over time.
    </p>
    <p>
      This option is available for <b>Bar and Line charts</b> when you use a{' '}
      <b>summarize step</b> in the Query Builder with <b>one metric</b> and{' '}
      <b>one dimension (must be a date)</b>.
    </p>
    <img width="1430" height="984" src="/img/cumulative.png" />
    <p>
      Please note, the total is calculated based on{' '}
      <b>the rows returned by your query</b>&nbsp; (up to a max of 100 in the
      Query Builder tab and 300 in the Dashboards tab) and not ALL the data in
      the underlying data set. This gives you the ability to calculate the
      cumulative total for a <b>given period of time</b>.
    </p>
    <p>
      To calculate the cumulative total <b>for a longer period</b>,&nbsp; you'll
      need to ensure that the total number of returned rows is less than the
      limits mentioned above. &nbsp; To achieve this, try changing the date
      dimension in your summarize step to MONTH or YEAR (as this will reduce the
      number of returned rows).
    </p>
  </span>
);

export const ROW_INDEX_EXPLAINER = (
  <span>
    <p>
      This is the row of the results table containing the value you want to
      show.
    </p>
    <p>
      <em>E.g. when set to 1, it will use the data from the first row.</em>
    </p>
    <p>
      Importanly, the <b>value will update</b> as the results change.
    </p>
    <p>
      For instance, if you're looking at data up to and including the current
      day and the <b>dimension in your Summarize step is set to "DAY"</b>, then
      the value in the first row will <b>change every day</b>.
    </p>
  </span>
);

export const SHOW_TREND_LABEL_EXPLAINER = (
  <span>
    <p>
      Your query results need to contain 2 columns: a <b>date</b> and a{' '}
      <b>number</b>.
    </p>
    <p>
      To achieve this, use the <b>Summarize step</b> in the Query Builder with a{' '}
      <b>single metric</b> and a <b>single dimension that's a date column</b>.
    </p>
    <div className={css.videoContainer}>
      <video
        style={{ width: '100%', borderRadius: '4px' }}
        width="1"
        autoPlay
        loop
        muted
        playsInline
        src="/video/trend_resized.mp4"
        type="video/mp4"
      />
    </div>
  </span>
);

export const BIG_QUERY_KEY_FILE = (
  <span>
    <p>
      You can get a key file when you create a new service account with Google:
    </p>
    <ol>
      <li>
        Head to{' '}
        <a
          rel="noopener"
          href="https://console.cloud.google.com"
          target="_blank"
        >
          console.cloud.google.com
        </a>
        .
      </li>
      <li>
        Click <b>IAM and Admin</b> in the left panel.
      </li>
      <li>
        Select <b>Service Accounts</b> from the list.
      </li>
      <li>
        Click the <b>Create Service Account</b> link (near the top)
      </li>
      <li>
        You'll need to grant two roles: <b>BigQuery Data Viewer</b> and{' '}
        <b>BigQuery User</b>.
      </li>
      <li>
        Once you click done, click the <b>email address</b> of your created
        service account.
      </li>
      <li>
        Click on the <b>KEYS</b> tab.
      </li>
      <li>
        Click <b>Add key</b> and select <b>create new key</b>
      </li>
      <li>
        Select <b>JSON</b> and then click <b>Create</b>.
      </li>
    </ol>
    <p>Once you have your key, upload it to Trevor.io.</p>
  </span>
);
